import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { I18nextProvider } from 'react-i18next'
import i18n from '../../../../i18n'
import { ThemeProvider } from 'styled-components'
import { appTheme } from 'spa/config/styled'
import Session from '../../../layouts/v2/Session'
import { session_path } from '../../../../routes'
import { WorkPreferenceForm } from 'spa/member/components/ProfileSheet/WorkPreferenceForm'
import { Button } from 'spa/member/components/Button'
import { Flash } from 'javascripts/layouts/v2/Flash'
import FlashType from 'javascripts/layouts/v2/FlashType'
import { useAtom } from 'jotai'
import { stateAtom } from 'spa/member/atoms/WorkPreference/stateAtom'
import { TODO_LIST_REFRESH_EVENT } from 'spa/member/atoms/TodoList/todoListAtom'
import { applyAnsweredGuidanceModalContent } from './applyAnsweredGuidanceModalContent'

export const SessionContext = React.createContext<Session>(null)

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('body.controller--profile_sheets-information_disclosures')) return false

  const workPreferenceFormDiv = document.querySelector('[data-react-profile-sheet-work-preference-form]') as HTMLDivElement

  if (workPreferenceFormDiv) {
    const root = createRoot(workPreferenceFormDiv)
    root.render(
      <WorkPreferenceFormForSlim />
    )
  }
})

const WorkPreferenceFormForSlim: React.FC = () => {
  const [session, setSession] = useState<Session>(null)
  const [flash, setFlash] = useState<FlashType>({})
  const [state] = useAtom(stateAtom)

  useEffect(() => {
    void fetch(session_path())
      .then(response => response.json())
      .then((json: Session) => setSession(json))
  }, [])

  const onSubmit = () => {
    window.scrollTo(0, 0)
    setFlash({ success: '保存しました' })
    setTimeout(() => setFlash({}), 3000)

    // 保存によってヘッダーの「登録後にやることリスト」の達成状況が変わるため再取得させる
    window.dispatchEvent(new Event(TODO_LIST_REFRESH_EVENT))

    // 保存＝カルテ回答完了。モーダルを回答済版に補正してから開く
    const modalStatus = document.getElementById('job_offer_guidance_modal_status')
    if (!modalStatus) return

    applyAnsweredGuidanceModalContent()
    // .value = ... ではObserverが発火しないため setAttribute を使う
    modalStatus.setAttribute('value', 'open')
  }

  return (
    <I18nextProvider i18n={i18n}>
      <SessionContext.Provider value={session}>
        <BrowserRouter>
          <ThemeProvider theme={appTheme}>
            {/* モーダル(z-1000)の背面に置くため、確実にCSSが生成される arbitrary 値で指定 */}
            <div className="fixed inset-x-0 z-[999]" style={{ top: 'var(--header-navbar-height, 4rem)' }}>
              <Flash flash={flash} />
            </div>
            <div className="mb-4XL">
              <WorkPreferenceForm onSubmit={onSubmit} />
            </div>
            <div className="flex justify-center">
              <Button
                type="submit"
                form="profile-sheet-work-preference-form"
                disabled={state.sending || state.profileSheetFormInvalid}
                className="bg-tech-apple-green-60! text-white!"
                style={{ width: '240px' }}
              >
                この内容で保存する
              </Button>
            </div>
          </ThemeProvider>
        </BrowserRouter>
      </SessionContext.Provider>
    </I18nextProvider>
  )
}
